import TotalsTable from '../components/TotalsTable';
import CustomTotalsTable from '../components/CustomTotalsTable';
import cartHasResale from './cartHasResale';

const pickTotalsTable = (widgetType, resaleOrderItems) => (
  widgetType === 'custom' && !cartHasResale(resaleOrderItems) ? CustomTotalsTable : TotalsTable
);

export default pickTotalsTable;
